export const formatOptionsByName = (options) =>
  options.map((option) => option.name);

export const formatOptionsById = (options) =>
  options.map((option) => option.id);

export const getOptionIdFromOptions = (options, value) =>
  options.find((option) => option.name === value)?.id;
